module.exports = __webpack_public_path__ + "img/AEGON_Life.1995b920.jpg";